// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"7996e3a0","213":"531e3a3f"}[chunkId] + ".chunk.js";
};